<div class="intel-ranking">
    <p class="intel-breadcrumb">
        <a (click)="goBack()">Unidades / Centro de inteligencia operativa</a> / {{titles.title}}
    </p>
    <div class="intel-header">
        <div>
            <p class="intel-title">{{titles.title}}</p>
            <p class="intel-subtitle">Análisis detallado de gastos, kilómetros recorridos y eficiencia operativa</p>
        </div>
        <div class="intel-header-controls">
            <app-date-range-picker
                [from]="filterFrom" [to]="filterTo"
                (fromChange)="filterFrom = $event" (toChange)="filterTo = $event"
                (rangeApplied)="applyFilters()">
            </app-date-range-picker>
            <div class="intel-compare-pill">
                <span class="intel-compare-label">Comparar con:</span>
                <span class="intel-compare-value">Período anterior</span>
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none"><path d="M6 9l6 6 6-6" stroke="#0a0a0a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </div>
        </div>
    </div>

    <div class="intel-filter-bar">
        <div class="intel-filter-group">
            <label>Cliente</label>
            <select [(ngModel)]="filterClientId">
                <option value="">Todos los clientes</option>
                <option *ngFor="let c of clients" [value]="c.id">{{c.name}}</option>
            </select>
        </div>
        <div class="intel-filter-group">
            <label>Unidad</label>
            <select [(ngModel)]="filterUnitId">
                <option value="">Todas las unidades</option>
                <option *ngFor="let u of units" [value]="u.id">{{u.unit}}</option>
            </select>
        </div>
        <div class="intel-filter-group">
            <label>Operador</label>
            <select [(ngModel)]="filterDriverId">
                <option value="">Todos los operadores</option>
                <option *ngFor="let d of drivers" [value]="d.id">{{d.name}}</option>
            </select>
        </div>
        <a class="intel-clear-link" (click)="clearFilters()">
            <img src="assets/img/icons/intel-clear-filters.svg" width="16" height="16" alt="">
            Limpiar filtros
        </a>
        <button type="button" class="intel-btn-primary" (click)="applyFilters()">Aplicar filtros</button>
    </div>

    <ng-container *ngIf="data">
        <div class="intel-kpi-grid">
            <app-kpi-card icon="assets/img/icons/intel-ranking-kpi-km.svg" iconBg="#dbeafe" label="Km recorrido total" [value]="formatKm(data.kpis.km_total.value)" [changePct]="data.kpis.km_total.change_pct" changeTone="good"></app-kpi-card>
            <app-kpi-card icon="assets/img/icons/intel-ranking-kpi-gasto.svg" iconBg="#dcfce7" label="Gasto operativo total" [value]="formatCurrency(data.kpis.gasto_total.value)" [changePct]="data.kpis.gasto_total.change_pct" changeTone="bad"></app-kpi-card>
            <app-kpi-card icon="assets/img/icons/intel-ranking-kpi-costo.svg" iconBg="#f3e8ff" label="Costo promedio por km" [value]="formatCurrency(data.kpis.cost_per_km.value)" [changePct]="data.kpis.cost_per_km.change_pct" changeTone="bad"></app-kpi-card>
            <app-kpi-card icon="assets/img/icons/intel-ranking-kpi-servicios.svg" iconBg="#ffedd4" label="Servicios realizados" [value]="data.kpis.services_count.value" [changePct]="data.kpis.services_count.change_pct" changeTone="good"></app-kpi-card>
        </div>

        <div class="intel-card">
            <p class="intel-card-title">Insights ejecutivos</p>
            <div class="intel-insights-grid">
                <div class="intel-insight" *ngIf="data.insights.most_efficient">
                    <div class="intel-insight-icon" style="background:#dcfce7">
                        <img src="assets/img/icons/intel-insight-eficiente.svg" width="16" height="16" alt="">
                    </div>
                    <div>
                        <p class="intel-insight-label">{{titles.column}} más eficiente</p>
                        <p class="intel-insight-name">{{data.insights.most_efficient.name}}</p>
                        <p class="intel-insight-value" style="color:#16a34a">{{formatCurrency(data.insights.most_efficient.cost_per_km)}} por km</p>
                        <p class="intel-insight-sub">{{data.insights.most_efficient.services_count}} servicios</p>
                    </div>
                </div>
                <div class="intel-insight" *ngIf="data.insights.most_expensive">
                    <div class="intel-insight-icon" style="background:#ffe2e2">
                        <img src="assets/img/icons/intel-insight-costoso.svg" width="16" height="16" alt="">
                    </div>
                    <div>
                        <p class="intel-insight-label">{{titles.column}} más costoso</p>
                        <p class="intel-insight-name">{{data.insights.most_expensive.name}}</p>
                        <p class="intel-insight-value" style="color:#dc2626">{{formatCurrency(data.insights.most_expensive.cost_per_km)}} por km</p>
                        <p class="intel-insight-sub">{{data.insights.most_expensive.services_count}} servicios</p>
                    </div>
                </div>
                <div class="intel-insight">
                    <div class="intel-insight-icon" style="background:#dbeafe">
                        <img src="assets/img/icons/intel-insight-promedio.svg" width="16" height="16" alt="">
                    </div>
                    <div>
                        <p class="intel-insight-label">Promedio general</p>
                        <p class="intel-insight-value">{{formatCurrency(data.insights.average_cost_per_km)}} <span class="intel-insight-sub-inline">por km</span></p>
                        <p class="intel-insight-sub">{{formatKm(data.kpis.km_total.value)}} recorridos | {{data.kpis.services_count.value}} servicios realizados</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="intel-two-col">
            <div class="intel-card">
                <p class="intel-card-title">Ranking rápido por costo por km</p>
                <div class="intel-quick-list">
                    <div class="intel-quick-row" *ngFor="let row of data.quick_ranking.top; let i = index">
                        <span class="intel-quick-rank">{{i + 1}}</span>
                        <span class="intel-quick-name">{{row.name}}</span>
                        <div class="intel-quick-bar-track"><div class="intel-quick-bar intel-quick-bar--good" [style.width]="barWidth(row.cost_per_km, data.quick_ranking.bottom[0]?.cost_per_km || row.cost_per_km)"></div></div>
                        <span class="intel-quick-value" style="color:#16a34a">{{formatCurrency(row.cost_per_km)}}</span>
                    </div>
                    <div class="intel-quick-row" *ngFor="let row of data.quick_ranking.bottom; let i = index">
                        <span class="intel-quick-rank">{{data.table.pagination.total - data.quick_ranking.bottom.length + i + 1}}</span>
                        <span class="intel-quick-name">{{row.name}}</span>
                        <div class="intel-quick-bar-track"><div class="intel-quick-bar intel-quick-bar--bad" [style.width]="barWidth(row.cost_per_km, data.quick_ranking.bottom[0]?.cost_per_km || row.cost_per_km)"></div></div>
                        <span class="intel-quick-value" style="color:#dc2626">{{formatCurrency(row.cost_per_km)}}</span>
                    </div>
                </div>
            </div>
            <div class="intel-card">
                <p class="intel-card-title">Distribución del gasto operativo</p>
                <app-donut-chart [slices]="data.distribution.slices" [total]="data.distribution.total"></app-donut-chart>
                <p class="intel-distribution-note">Los {{data.distribution.slices.length - 1}} principales concentran el <strong>{{data.distribution.top_concentration_pct}}%</strong> del gasto total</p>
            </div>
        </div>

        <div class="intel-card intel-table-card">
            <div class="intel-table-scroll">
                <table class="intel-full-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>{{titles.column}}</th>
                            <th>Km recorridos</th>
                            <th>Gasto total</th>
                            <th>Costo por km</th>
                            <th>Servicios realizados</th>
                            <th>Costo total operativo</th>
                            <th>Eficiencia por km</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of data.table.data; let i = index">
                            <td>{{(currentPage - 1) * perPage + i + 1}}</td>
                            <td class="cell-name-link" (click)="goToHistory(row.id)">{{row.name}}</td>
                            <td>{{formatKm(row.km_total)}}</td>
                            <td>{{formatCurrency(row.gasto_total)}}</td>
                            <td [ngClass]="costPerKmClass(row.cost_per_km)">{{row.cost_per_km !== null ? formatCurrency(row.cost_per_km) : '—'}}</td>
                            <td>{{row.services_count}}</td>
                            <td>{{formatCurrency(row.gasto_total)}}</td>
                            <td><app-efficiency-badge [label]="row.efficiency"></app-efficiency-badge></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="intel-pagination-bar" *ngIf="data.table.pagination.total > 0">
                <span>Mostrando {{(currentPage - 1) * perPage + 1}} a {{Math.min(currentPage * perPage, data.table.pagination.total)}} de {{data.table.pagination.total}} {{titles.entityPlural}}</span>
                <div class="intel-pagination" *ngIf="data.table.pagination.last_page > 1">
                    <button type="button" [disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)">‹</button>
                    <button type="button" *ngFor="let p of pageNumbers" [class.active]="p === currentPage" (click)="goToPage(p)">{{p}}</button>
                    <button type="button" [disabled]="currentPage === data.table.pagination.last_page" (click)="goToPage(currentPage + 1)">›</button>
                </div>
            </div>
        </div>
    </ng-container>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <p style="font-size: 20px; color: white">Espere un momento...</p>
</ngx-spinner>
